<template>
  <div class="c-document-row">
    <ul>
      <li v-if="data.type !== 'zip'">
        <a @click.prevent="previewFile(data.id)">{{ data.fname }}</a>
      </li>
      <li v-else>
        {{ data.fname }}
      </li>
      <li>{{ formatSize(data.size) }}</li>
      <li><i :class="`doctype-img32 ${data.type}`" /></li>
      <li>
        <button
          v-if="data.type === 'zip'"
          class="btn btn-default"
          @click="downloadArchive(data.id)"
        >
          Скачать
        </button>
        <button
          v-else
          class="btn btn-default"
          @click="downloadFile(data.id)"
        >
          Скачать
        </button>
      </li>
    </ul>
  </div>
</template>

<script>

import apiService from '../../apiService'
import { formatSize, joinImpersonate } from '../../../../../../../resources/js/helper'
import { Notification } from 'uiv'

export default {
  name: 'CDocumentRow',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      fetchingFiles: false
    }
  },
  methods: {
    /**
     * Скачивание архива
     * @param id ID документа
     */
    downloadArchive (id) {
      this.fetchArchiveForDownload(id).then(() => {
        window.open(joinImpersonate(`/api/context/download?id=${id}`), '_blank')
      })
    },
    /**
     * Скачивание файла
     * @param id ID файла
     */
    downloadFile (id) {
      this.fetchFileForDownload(id).then(() => {
        window.open(joinImpersonate(`/api/context/download/file?id=${id}`), '_blank')
      })
    },
    /**
     * Просмотр файла
     * @param id ID файла
     */
    previewFile (id) {
      this.fetchFileForPreview(id).then(() => {
        window.open(joinImpersonate(`/api/context/preview/file?id=${id}`), '_blank')
      })
    },
    /**
     * Метод-обёртка над запросом к API /api/context/download
     * @returns {Promise<AxiosResponse<T>>}
     */
    fetchArchiveForDownload (id) {
      this.fetchingFiles = true
      return new Promise(resolve => {
        apiService.getArchiveForDownload(id)
          .then(response => {
            this.fetchingFiles = false
            resolve(response.data)
          })
          .catch(() => {
            this.fetchingFiles = false
            Notification.notify.error({
              title: 'Ошибка',
              content: 'Не удалось скачать архив'
            })
          })
      })
    },
    /**
     * Метод-обёртка над запросом к API /api/context/download/file
     * @returns {Promise<AxiosResponse<T>>}
     */
    fetchFileForDownload (id) {
      this.fetchingFiles = true
      return new Promise(resolve => {
        apiService.getFileForDownload(id)
          .then(response => {
            this.fetchingFiles = false
            resolve(response.data)
          })
          .catch(() => {
            this.fetchingFiles = false
            Notification.notify.error({
              title: 'Ошибка',
              content: 'Не удалось скачать файл'
            })
          })
      })
    },
    /**
     * Метод-обёртка над запросом к API /api/context/preview/file
     * @returns {Promise<AxiosResponse<T>>}
     */
    fetchFileForPreview (id) {
      this.fetchingFiles = true
      return new Promise(resolve => {
        apiService.getFileForPreview(id)
          .then(response => {
            this.fetchingFiles = false
            resolve(response.data)
          })
          .catch(() => {
            this.fetchingFiles = false
            Notification.notify.error({
              title: 'Ошибка',
              content: 'Не удалось открыть файл'
            })
          })
      })
    },
    formatSize
  }
}
</script>

<style scoped lang="scss">
.c-document-row {
  ul {
    display: flex;
    margin-bottom: 0;
    padding: 0;
    li {
      display: inline-flex;
      margin-bottom: 1px;
      flex: 1;
      align-items: center;
      justify-content: center;
      &:first-child {
        flex: 2;
        justify-content: left;
      }
      &:last-child {
        justify-content: right;
      }
      & > a {
        cursor: pointer;
      }
    }
  }
  i.doctype-img32 {
    width: 32px;
    height: 32px;
    background-position: center;
    &.docx {
      background-image: url(../../../images/doctypes/doctype_docx.png);
    }
    &.pdf {
      background-image: url(../../../images/doctypes/doctype_pdf.png);
    }
    &.xlsx {
      background-image: url(../../../images/doctypes/doctype_xlsx.png);
    }
    &.zip {
      background-image: url(../../../images/doctypes/doctype_zip.png);
    }
  }
}
</style>
